<template>
  <div class="article-list-wrap">
    <ArticleOption v-model:now-cate="nowPageCate" :categories="categories" />
    <ArticleList :category-name="nowPageCate" :is-list="true" :is-click-more="true" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';
import ArticleOption from '@page/article/components/parts/ArticleOption.vue';
import ArticleList from '@page/article/components/parts/ArticleList.vue';

const { getArticleCategoryAPI } = useAxiosAPI();

const categories = ref([]);
const nowPageCate = computed(() => {
  const urlCate = window.location.href.split('/mag/')[1];
  return urlCate ? decodeURI(urlCate) : 'ALL';
});

function getCategory() {
  getArticleCategoryAPI()
    .then((res) => {
      if (res.data.Code === 200) {
        categories.value = res.data.Response.Categories;
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

getCategory();
</script>
